import { Canvas } from '@react-three/fiber';
import { FC, Suspense } from 'react';
import { ModelRenderer } from './ModelRenderer';
import { ScanModel } from '../../network';
import { SyncedCameraControls } from '../SyncedControls/SyncedControls';
import { Floor } from '../3dModels/Floor';
import { CanvasItemId } from '../CompareControls/CanvasItemId';
import { ThreeJsLoader } from '../ui/ThreeJsLoader';
import { LinearEncoding, NoToneMapping } from 'three';
import { QualityClassAlert } from '../../ui/ScanStatusChips';

export type SourceId = 'primary' | 'secondary';

interface CanvasViewProps {
  scan: ScanModel;
  accessToken: string;
  sourceId: 'primary' | 'secondary';
}

export const CanvasView: FC<CanvasViewProps> = ({
  scan,
  accessToken,
  sourceId,
}) => {
  return (
    <div
      style={{
        background: 'lightgray',
        borderRadius: '16px',
        position: 'relative',
        flex: 1,
        overflow: 'hidden',
      }}
    >
      <Canvas
        gl={{
          toneMapping: NoToneMapping,
          outputEncoding: LinearEncoding,
        }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
        }}
        resize={{
          scroll: false,
          debounce: 16,
        }}
        shadows
      >
        <Suspense fallback={<ThreeJsLoader />}>
          <axesHelper position={[0, 0, 0]} scale={2} />
          <ambientLight intensity={0.75} color={0xffffff} />
          <directionalLight position={[1, 1, 1]} intensity={0.3} castShadow />
          <directionalLight position={[-1, -1, -1]} intensity={0.3} />

          <ModelRenderer scan={scan} accessToken={accessToken} />
          <Floor />

          <SyncedCameraControls sourceId={sourceId} makeDefault />
        </Suspense>
      </Canvas>
      <CanvasItemId id={scan.id} sourceId={sourceId} />
      <QualityClassAlert
        qualityClass={scan.predicted_bent_deviation_mesh_quality_class}
      />
    </div>
  );
};
